import update from 'immutability-helper'
import * as ActionTypes from '../../constants/link/LInkMeActionTypes'

const initialState = {
    links: [],
    totalCount : null,
    sort : 'createdAt',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.RECEIVE_LINK_ME:
            return update(state, {
                links : {
                    $set: action.data.links,
                },
                totalCount : {
                    $set: action.data.totalCount,
                }
            }
        );

        case ActionTypes.CHANGE_SORT_OPTION:
            return update(state, {
                    sort : {
                        $set: action.data,
                    }
                }
            );

        case ActionTypes.UPDATE_LINK_ME:
            return update(state, {
                links: {
                    $splice: [
                        [state.links.findIndex((link) => link.linkId === action.data.linkId), 1, action.data]
                    ]
                },
            });
        default:
            return state
    }
}
